import { createSlice } from "@reduxjs/toolkit";

export const Select1dGameTime = (state) => state.gameInfo1dSlice?.gameTimer
export const Select1dCurrentGameTime = (state) => state.gameInfo1dSlice?.current_game_time
export const Select1dNextGameTime = (state) => state.gameInfo1dSlice?.next_game_time
export const Select1dCoupenValue = (state) => state.gameInfo1dSlice?.coupen_value
export const Select1dUserWallet = (state) => state.gameInfo1dSlice?.user_wallet
export const Select1dLastWinCard = (state) => state.gameInfo1dSlice?.last_win_Card
export const Select1dTimeSlot = (state) => state.gameInfo1dSlice?.TIME_SLOT
export const Select1dAdvanceDrawSelectTime = (state) => state.gameInfo1dSlice?.ADVANCE_DRAW_SELECT_TIME
export const Select1dLastSaleAmount = (state) => state.gameInfo1dSlice?.last_sale_amount
export const Select1dLastTicketId = (state) => state.gameInfo1dSlice?.last_ticket_id
export const Select1dLotteryReport = (state) => state.gameInfo1dSlice?.lottery_Report
export const Select1dClaimTicket = (state) => state.gameInfo1dSlice?.claim_ticket_id
export const Select1dClaimTicketRecord = (state) => state.gameInfo1dSlice?.claim_ticket_record
export const Select1dReprintList = (state) => state.gameInfo1dSlice?.rePrint_list
export const Select1dResultData = (state) => state.gameInfo1dSlice?.result_data
export const Select1dAutoResultData = (state) => state.gameInfo1dSlice?.autoResultData
export const Select1dAnnoucements = (state) => state.gameInfo1dSlice?.annoucements
export const Select1dPreviewsTime = (state) => state.gameInfo1dSlice?.previews_game_time
export const Select1dGameID = (state) => state.gameInfo1dSlice?.game_id
export const Select1dWinLoseRecord = (state) => state.gameInfo1dSlice?.win_lose
export const select1dPickResultDates = (state) => state.gameInfo1dSlice?.PICK_Result_Dates;
export const select1dPickResultTime = (state) => state.gameInfo1dSlice?.PICK_Result_time;
export const select1dPrint = (state) => state.gameInfo1dSlice?.Print_data;


const gameInfo1dSlice = createSlice({
  name: "gameInfo1dSlice",
  initialState: {
    gameTimer: true,
    current_game_time: null,
    next_game_time: null,
    coupen_value: null,
    user_wallet: 0,
    last_win_Card: [],
    TIME_SLOT: [],
    ADVANCE_DRAW_SELECT_TIME: [],
    // last_sale_amount: null,
    last_ticket_id: null,
    lottery_Report: [],
    PICK_Result_Dates: [],
    PICK_Result_time: {},
    claim_ticket_id: '',
    claim_ticket_record: {},
    rePrint_list: [],
    Print_data: [],
    result_data: [],
    result_data_dates: [],
    autoResultData: [],
    annoucements: '',
    previews_game_time: null,
    game_id: '',
    win_lose: {}
  },
  reducers: {
    SET_1D_GAME_TIMER: (state, { payload }) => { state.gameTimer = payload },
    SET_1D_CURRENT_GAME_TIME: (state, { payload }) => { state.current_game_time = payload },
    SET_1D_NEXT_GAME_TIME: (state, { payload }) => { state.next_game_time = payload },
    SET_1D_COUPEN_VALUE: (state, { payload }) => { state.coupen_value = payload },
    SET_1D_USER_WALLET: (state, { payload }) => { state.user_wallet = payload },
    SET_1D_LAST_WIN_CARD: (state, { payload }) => { state.last_win_Card = [...payload] },
    SET_1D_TIME_SLOT: (state, { payload }) => { state.TIME_SLOT = [...payload] },
    SET_1D_ADVANCE_DRAW_SELECT_TIME: (state, { payload }) => { state.ADVANCE_DRAW_SELECT_TIME = [...payload] },
    SET_1D_LAST_SALE_AMOUNT: (state, { payload }) => { state.last_sale_amount = payload },
    SET_1D_LAST_TICKET_ID: (state, { payload }) => { state.last_ticket_id = payload },
    SET_1D_LOTTERY_REPORT: (state, { payload }) => { state.lottery_Report = [...payload] },
    SET_1D_CLAIM_TICKET_ID: (state, { payload }) => { state.claim_ticket_id = payload },
    SET_1D_CLAIM_TICKET_RECORD: (state, { payload }) => { state.claim_ticket_record = { ...payload } },
    SET_1D_REPRNT_LIST: (state, { payload }) => { state.rePrint_list = [...payload] },
    SET_1D_RESULT_DATA: (state, { payload }) => { state.result_data = [...payload] },
    SET_1D_AUTO_RESULT_DATA: (state, { payload }) => { state.autoResultData = [...payload] },
    SET_1D_ANNOUCEMENTS: (state, { payload }) => { state.annoucements = payload },
    SET_1D_PREVIEWS_GAME_TIME: (state, { payload }) => { state.previews_game_time = payload },
    SET_1D_TR_CODE: (state, { payload }) => { state.game_id = payload },
    SET_1D_WIN_LOSE_RECORD: (state, { payload }) => { state.win_lose = payload },
    SET_RESULT_DATES_1D: (state, action) => {
      state.PICK_Result_Dates = [...action.payload];
    },
    SET_RESULT_TIME_1D: (state, action) => {
      state.PICK_Result_time = { ...action.payload };
    },
    SET_1D_PRINT_DATA: (state, action) => {
      state.Print_data = { ...action.payload };
    },
    clear1DWinLoseRecord: (state) => {
      state.win_lose = {};
    }
  }
})





export const {
  SET_1D_GAME_TIMER, SET_1D_CURRENT_GAME_TIME, SET_1D_NEXT_GAME_TIME,
  SET_1D_COUPEN_VALUE, SET_1D_USER_WALLET, SET_1D_LAST_WIN_CARD, SET_1D_TIME_SLOT,
  SET_1D_ADVANCE_DRAW_SELECT_TIME, SET_1D_LAST_SALE_AMOUNT, SET_1D_LAST_TICKET_ID,
  SET_1D_LOTTERY_REPORT, SET_1D_CLAIM_TICKET_ID, SET_1D_CLAIM_TICKET_RECORD, SET_1D_PRINT_DATA,
  SET_1D_REPRNT_LIST, SET_1D_RESULT_DATA, SET_1D_AUTO_RESULT_DATA, SET_1D_ANNOUCEMENTS,
  SET_1D_PREVIEWS_GAME_TIME, SET_1D_TR_CODE, SET_1D_WIN_LOSE_RECORD, SET_RESULT_DATES_1D, SET_RESULT_TIME_1D, clear1DWinLoseRecord

} = gameInfo1dSlice.actions;

export default gameInfo1dSlice.reducer;